
    import { Vue, Component, Prop } from 'vue-property-decorator'
    import { AddressStyleTranslationMixin } from '@/app/common/helpers/address-style-translation'

    type TwoFactorMethod = 'totp' | 'email'

    @Component({
        mixins: [AddressStyleTranslationMixin]
    })
    export default class TwofactorEnabledCard extends Vue {
        // Type declaration for mixin method
        $ta!: (key: string, values?: Record<string, unknown>) => string

        @Prop({ type: String, required: true }) currentMethod!: TwoFactorMethod
        @Prop({ type: Boolean, default: false }) allowEmailTwoFactor!: boolean
        @Prop({ type: Boolean, default: false }) twoFactorMandatory!: boolean

        get currentMethodLabel(): string {
            return this.currentMethod === 'totp'
                ? (this.$t('page.twofactor.method.app_title') as string)
                : (this.$t('page.twofactor.method.email') as string)
        }
    }
